<template>
    <div class="content-box">
        <Title/>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "exposure",
    data() {
        return {
            params: {
                json: 1,
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', '电诉宝跨境')
        this.$store.dispatch('getText')
    },
}
</script>